import React from 'react'
import { Fragment } from 'react';
import { Table } from 'react-bootstrap';
import { DATE_FORMAT } from '../../../../utils/config';

const Extra_row = ({data}) => {
   
    const isDateFormat=(fromdata,todata)=> {
      let dateFrom = new Date(fromdata);
      let dateTo = new Date(todata);
 
      let yearfrom = dateFrom.getFullYear();
      let dayfrom = dateFrom.getDate();
 
      let monthfrom = dateFrom.getMonth();
 
      let year = dateTo.getFullYear();
 
      let day = dateTo.getDate();
      let month = dateTo.getMonth();
 
      if (`${dayfrom.length === 1}`) dayfrom = `0${dayfrom}`;
      if (`${monthfrom.length === 1}`) monthfrom = `0${monthfrom}`;
 
      if (`${day}`.length === 1) day = `0${day}`;
      if (`${month}`.length === 1) month = `0${month}`;
 
      if (DATE_FORMAT === "DD-MM-YYYY")
        return `${dayfrom}-${monthfrom}-${yearfrom} to ${day}-${month}-${year}`;
 
      return `${month}-${day}-${year}`;
    }

const rows = data.map((item)  => 
    <>
      
    
          <tr>
            <td><p >{item.extCurActType}</p></td>
            <td><p >{item.extCurActName}</p></td>
            <td><p >{isDateFormat(item.fromDate,item.toDate)}</p></td>
          </tr>
    
   
        
      
    </>
)
return (
<>
<Table bordered style={{"border-style": "solid"}}>
        <thead>
          <tr>
            <th><h6>Activity Type</h6></th>
            <th><h6>Activity Name</h6></th>
            <th><h6>Duration</h6></th>
          </tr>
        </thead>
        <tbody>
<Fragment>{rows}</Fragment> 
</tbody>
</Table>
</>
)
};

export default Extra_row